
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Users, TrendingUp, Sparkles } from "lucide-react";

const CtaSection: React.FC = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="bg-gradient-to-r from-primary/10 to-secondary/20 rounded-2xl p-10 md:p-16 text-center relative overflow-hidden">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 opacity-10">
            <TrendingUp className="h-32 w-32 text-primary" />
          </div>
          
          <Badge variant="secondary" className="mb-4 px-4 py-2 font-medium">
            <Users className="h-4 w-4 mr-2" />
            Join 10,000+ Users
          </Badge>
          
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to 10x Your Productivity?
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Start with our free plan and see immediate results. Upgrade to Pro for unlimited access and Product Copilot.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <Button asChild size="lg" className="rounded-full px-8 text-lg">
              <Link to="/sign-up">Start Free Today</Link>
            </Button>
            <Button 
              asChild 
              variant="outline" 
              size="lg" 
              className="rounded-full px-8 text-lg bg-green-50 text-green-700 border-green-200 hover:bg-green-100"
            >
              <Link to="/product-copilot" className="flex items-center gap-2">
                <Sparkles className="h-5 w-5" />
                Try Product Copilot
              </Link>
            </Button>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span>Free plan available</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span>No credit card required</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
              <span>Instant access</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
